import React from 'react'
import {COLOR_LIST} from "../common/constants/color.constant";
import _ from "lodash";

const colorList = _.orderBy(COLOR_LIST, 'colorKey');

const EditColorDetails = ({displayTextItem, handleColorDetailsChanges}) => {
    const colorMap = _.keyBy(COLOR_LIST, 'colorKey');

    return (
        <>

            <div className="ml-2 field-label">
                Text Color
            </div>

            <div className="flex justify-start move-up-10">
                <div className="field-group-container">
                    <div className="field-container">
                        <select
                            className="input-field"
                            id="colorKey"
                            name="colorKey"
                            value={displayTextItem?.colorKey}
                            onChange={handleColorDetailsChanges}>
                            <option value="">Choose Color</option>
                            {colorList?.map((colorDetail, index) => (
                                <option key={index}
                                        value={colorDetail.colorKey}>{colorDetail.colorName}</option>
                            ))}
                        </select>
                    </div>
                    <div className="field-container">
                        <select
                            className="input-field"
                            id="colorCodeKey"
                            name="colorCodeKey"
                            value={displayTextItem?.colorCodeKey}
                            onChange={handleColorDetailsChanges}>
                            <option value="">Choose Shade</option>
                            {colorMap[displayTextItem?.colorKey]?.colorCodes.map((colorCodeDetail, index) => (
                                <option key={index}
                                        value={colorCodeDetail.colorCodeKey}>{colorCodeDetail.colorCodeName}</option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>

        </>
    )
}

export default EditColorDetails
